<script setup lang="ts">
import LinkDiagnosticDialog from "@/components/files/DrawingList/LinkDiagnosticDialog.vue";
import { useDrawingDiagnosticLink } from "@/composable/useDrawingDiagnosticLink";

/**
 * Modale de rattachement du plan ouvert à un ouvrage, aux couleurs du
 * canvas. Commune aux onglets du volet Observations : elle reprend le lien
 * plan ↔ ouvrage partagé par le volet et le relit une fois le plan lié.
 */

const props = defineProps<{
  drawingId: number;
}>();

const visible = defineModel<boolean>({ required: true });

const { drawing, loadDrawing } = useDrawingDiagnosticLink(props.drawingId);
</script>

<template>
  <LinkDiagnosticDialog
    v-if="drawing"
    v-model="visible"
    :drawing-id="drawingId"
    :project-id="drawing.projectId"
    :drawing-name="drawing.name"
    :diagnostic="drawing.diagnostic"
    canvas-theme
    @linked="loadDrawing"
  />
</template>
